import axios from 'axios';
import { API } from '../global/global';

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
  Accept: 'application/json',
});

export interface Permiso {
  id: number;
  slug: string;
  nombre: string;
  modulo: string;
  descripcion: string;
}

export interface RolConPermisos {
  id: number;
  nombre: string;
  descripcion: string;
  nivel: number;
  estatus: number;
  usuarios_count?: number;
}

export const permisosApi = {
  getMatriz: async (): Promise<{ permisos: Permiso[]; roles: RolConPermisos[]; matriz: Record<number, Record<number, boolean>> }> => {
    const res = await axios.get(`${API}/permisos`, { headers: getAuthHeaders() });
    return res.data;
  },

  actualizarPermisos: async (rolId: number, permisos: Record<number, boolean>): Promise<any> => {
    const res = await axios.put(`${API}/permisos/rol/${rolId}`, { permisos }, { headers: getAuthHeaders() });
    return res.data;
  },

  getRoles: async (): Promise<RolConPermisos[]> => {
    const res = await axios.get(`${API}/roles`, { headers: getAuthHeaders() });
    return res.data.data || [];
  },

  crearRol: async (data: { nombre: string; descripcion?: string; nivel: number }): Promise<any> => {
    const res = await axios.post(`${API}/roles`, data, { headers: getAuthHeaders() });
    return res.data;
  },

  editarRol: async (id: number, data: { nombre?: string; descripcion?: string; nivel?: number }): Promise<any> => {
    const res = await axios.put(`${API}/roles/${id}`, data, { headers: getAuthHeaders() });
    return res.data;
  },
};
